<template>
  <el-dialog :title="stageLabel ? '上传地图影像 - ' + stageLabel : '上传地图影像'" :visible.sync="visibleSync" width="700px">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="2D地图" name="2d">
        <el-form label-width="120px">
          <el-form-item label="地图场景地址">
            <el-input v-model="form.map2dSceneUrl" type="textarea" :rows="6" placeholder="请输入场景地址" />
          </el-form-item>
          <el-form-item label="SessionKey">
            <el-input v-model="form.map2dSessionKey" placeholder="请输入SessionKey" />
          </el-form-item>
          <el-form-item label="AppID">
            <el-input v-model="form.map2dAppId" placeholder="请输入AppID" />
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="3D地图" name="3d">
        <el-form label-width="120px">
          <el-form-item label="地图场景地址">
            <el-input v-model="form.map3dSceneUrl" type="textarea" :rows="6" placeholder="请输入场景地址" />
          </el-form-item>
          <el-form-item label="SessionKey">
            <el-input v-model="form.map3dSessionKey" placeholder="请输入SessionKey" />
          </el-form-item>
          <el-form-item label="AppID">
            <el-input v-model="form.map3dAppId" placeholder="请输入AppID" />
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <div class="tips">
      <p>温馨提示：由于地图数据较大，请到平台上传后再复制链接到这里填入。</p>
      <el-button type="text" @click="openUploadPlatform">去上传</el-button>
      <el-button type="text" @click="guideVisible = true">上传指南</el-button>
    </div>

    <span slot="footer">
      <el-button @click="visibleSync = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">提交</el-button>
    </span>

    <!-- 上传指南弹窗 -->
    <el-dialog title="上传指南" :visible.sync="guideVisible" width="500px" append-to-body>
      <ol>
        <li>登录四维轻云后台</li>
        <li>点击"全部场景"</li>
        <li>新建场景并上传数据</li>
        <li>点击场景的3个点菜单，选择"获取地址"复制场景地址</li>
        <li>点击"场景SDK"，获取 AppID 和 密钥Key</li>
        <li>将以上信息填入本页面对应输入框</li>
      </ol>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    stageId: Number
  },
  data() {
    return {
      activeTab: "2d",
      guideVisible: false,
      stageLabel: "",
      form: {
        map2dSceneUrl: "",
        map2dSessionKey: "",
        map2dAppId: "",
        map3dSceneUrl: "",
        map3dSessionKey: "",
        map3dAppId: ""
      }
    };
  },
  computed: {
    visibleSync: {
      get() { return this.visible; },
      set(val) { this.$emit("update:visible", val); }
    }
  },
  watch: {
    visible(val) {
      if (val) this.loadDetail();
    }
  },
  methods: {
    loadDetail() {
      if (!this.stageId) return;
      this.$apis.get("/admin/spot/stage/detail", { stageId: this.stageId }).then(res => {
        if (res.data.code == 200 && res.data.data) {
          const d = res.data.data;
          this.stageLabel = d.label || "";
          this.form.map2dSceneUrl = d.map2dSceneUrl || "";
          this.form.map2dSessionKey = d.map2dSessionKey || "";
          this.form.map2dAppId = d.map2dAppId || "";
          this.form.map3dSceneUrl = d.map3dSceneUrl || "";
          this.form.map3dSessionKey = d.map3dSessionKey || "";
          this.form.map3dAppId = d.map3dAppId || "";
        }
      });
    },
    handleSubmit() {
      const params = {
        stageId: this.stageId,
        ...this.form
      };
      this.$apis.post("/admin/spot/stage/map/save", params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("保存成功");
          this.visibleSync = false;
          this.$emit("success");
        } else {
          this.$message.error(res.data.msg || "保存失败");
        }
      });
    },
    openUploadPlatform() {
      window.open("https://www.swqyun.com/", "_blank");
    }
  }
};
</script>

<style scoped>
.tips {
  margin-top: 16px;
  padding: 12px;
  background: #f5f7fa;
  border-radius: 4px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/page/components/spotStageMapUpload.vue